import { Provider } from '@angular/core';

import { MainApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const DataContentGrpcContractProvider: Provider = {
  provide: MainApi.DataContentGrpcContractClient,
  useFactory: CommonGrpcContractFactory(MainApi.DataContentGrpcContractClient, 'mainApi'),
};
